(function () {
    'use strict';
    angular.module('emarket.main.category', [ 'ui.router' ])
      .config(['$stateProvider', function ($stateProvider) {
          $stateProvider.state('main.category', {
              url: '/categoria?categoria',
              views: {
                  main: {
                      controller: 'CategoryController as vm',
                      templateUrl: 'main/category/category.tpl.html'
                  }
              }
          });
      }]);
}());

(function () {
    'use strict';
    angular.module('emarket.main.category', [ 'ui.router' ])
      .config(['$stateProvider', function ($stateProvider) {
          $stateProvider.state('main.category', {
              url: '/categoria?categoria',
              views: {
                  main: {
                      controller: 'CategoryController as vm',
                      templateUrl: 'main/category/category.tpl.html'
                  }
              }
          });
      }]);
}());
